import { ChevronDown, ChevronRight } from 'lucide-react';
import { StatusPip, statusPipForPeriod } from '../../components/ui/status-pip';
import { formatMoney, monthLabel } from '../../lib/utils';
import type { AdminPeriodCard } from '../../lib/resources/types';
import { PeriodDetail } from './period-detail';

interface PeriodRowProps {
  card: AdminPeriodCard;
  expanded: boolean;
  onToggle: () => void;
}

/** Collapsible row in /admin overview — header + (if expanded) {@link PeriodDetail} body. */
export function PeriodRow({ card, expanded, onToggle }: PeriodRowProps) {
  return (
    <li>
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-center gap-4 px-6 py-4 text-left hover:bg-overlay transition-colors"
      >
        {expanded ? <ChevronDown className="size-4" /> : <ChevronRight className="size-4" />}
        <span className="font-medium w-40">{monthLabel(card.year, card.month)}</span>
        <StatusPip {...statusPipForPeriod(card.status)} />
        <span className="text-[12px] text-foreground-muted">
          {card.finalizedSubmissionsCount}/{card.totalSubmissionsCount} contractors
        </span>
        {card.masterInvoiceTotalCents != null && (
          <span className="font-mono ml-auto">{formatMoney(card.masterInvoiceTotalCents)}</span>
        )}
        {card.masterInvoiceNumber && (
          <span className="font-mono text-foreground-muted text-[12px]">{card.masterInvoiceNumber}</span>
        )}
      </button>
      {expanded && <PeriodDetail periodId={card.id} card={card} />}
    </li>
  );
}
